<template>
  <CardTable class="CardSolarInverter">
    <Row>
      <Column :lg="6">
        <Set icon="sun" name="Gamintojas">
          {{ solarInverter.manufacturer }}
        </Set>
      </Column>
      <Column :lg="6">
        <Set icon="bolt" name="Modelis">
          {{ solarInverter.model }}
        </Set>
      </Column>
    </Row>
    <div slot="actions">
      <Route
        :id="solarInverter.id"
        class="Btn ib sm info"
        to="AdminSolarInverter">
        Redaguoti
      </Route>
    </div>
  </CardTable>
</template>

<script>
import CardTable from './CardTable'
import Set from '../Set'
import { getters } from '../../utils'

export default {
  components: { CardTable, Set },
  props: {
    solarInverter: Object,
  },
  // data() {
  //   return {
  //     isOpen: false,
  //   }
  // },
  computed: {
    ...getters(),
  },
}
</script>

<style lang="scss">
</style>
